// extracted by mini-css-extract-plugin
module.exports = {"title":"ExcelModal_title__SYSHZ","container":"ExcelModal_container__3OG-8","button":"ExcelModal_button__K5jKW","dateTag":"ExcelModal_dateTag__2Cdxt"};